module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "mb"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('label.ipAddress')) + ":")]), _vm._v(" " + _vm._s(_vm.status.address))]), _vm._v(" "), _c('div', {
    staticClass: "mb"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('label.hostName')) + ":")]), _vm._v(" " + _vm._s(_vm.status.hostName))]), _vm._v(" "), _c('div', {
    staticClass: "mb"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('label.gatewayIp')) + ":")]), _vm._v(" " + _vm._s(_vm.status.gatewayIp))]), _vm._v(" "), _c('div', {
    staticClass: "mb"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('label.isGatewayAlive')) + ":")]), _vm._v(" " + _vm._s(_vm.status.isGatewayAlive))]), _vm._v(" "), _c('div', {
    staticClass: "mb"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('label.publicIp')) + ":")]), _vm._v(" " + _vm._s(_vm.status.publicIp))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.updateStatus
    }
  }, [_c('fa-icon', {
    attrs: {
      "icon": "refresh",
      "animated": _vm.loading
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.refresh')) + "\n    ")], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-13c44213!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/LANStatus.vue
// module id = 1125
// module chunks = 2